class PanUndoUnit {
    constructor(initialPosition, finalPosition, diagram) {
        this.initial = initialPosition;
        this.finalPos = finalPosition;
        this.diagram = diagram;
        this.title = 'Pan Unit';
    }
    undo() {
        this.diagram.pan(this.initial);
    }
    redo() {
        this.diagram.pan(this.finalPos);
    }
}

export { PanUndoUnit };
